"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var react_router_dom_1 = require("react-router-dom");

var semantic_ui_react_1 = require("semantic-ui-react");

var data_1 = require("../data");

var LandingPage =
/** @class */
function (_super) {
  __extends(LandingPage, _super);

  function LandingPage(props) {
    return _super.call(this, props) || this;
  }

  LandingPage.prototype.render = function () {
    return React.createElement(semantic_ui_react_1.Container, {
      fluid: false
    }, React.createElement(semantic_ui_react_1.Segment, {
      basic: true,
      padded: 'very'
    }, React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      padded: true,
      relaxed: true
    }, this.renderFeaturedStories(), this.renderFeaturedVisualizations(), this.renderFeaturedDatasets())));
  };

  LandingPage.prototype.renderSingleVisualization = function (viz) {
    return React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 3
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement("img", {
      src: "assets/icons/" + viz.name.toLocaleLowerCase() + "-thumbnail.png",
      style: {
        height: '90px',
        width: '90px'
      },
      alt: "viz " + viz.name + " icon"
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left',
      width: 8
    }, React.createElement(semantic_ui_react_1.Header, null, viz.name), viz.summary, React.createElement("p", null, React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, viz.listAsOriginal ? 'Original authors' : 'Authors', ": "), viz.authors.length === 2 ? viz.authors[0] + " and " + viz.authors[1] : viz.authors.join(', ')), React.createElement("br", null)), React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: {
        pathname: '/visualizations/',
        search: "?name=" + viz.name.toLocaleLowerCase()
      }
    }, "details"))), React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: {
        pathname: '/dataset',
        search: "?viz=" + viz.name.toLocaleLowerCase()
      }
    }, "launch")))));
  };

  LandingPage.prototype.renderFeaturedDatasets = function () {
    return React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: true
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(semantic_ui_react_1.Header, {
      floated: 'left'
    }, "Featured Datasets"), React.createElement(semantic_ui_react_1.Divider, {
      section: true
    }))), React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 2,
      divided: true
    }, this.renderHCADatasets(), this.renderUserSharedDatasets()), React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: false
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(react_router_dom_1.Link, {
      style: {
        color: 'blue',
        float: 'right'
      },
      to: 'datasets'
    }, "more datasets..."))));
  };

  LandingPage.prototype.renderFeaturedStories = function () {
    return React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: false
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(semantic_ui_react_1.Header, {
      floated: 'left'
    }, "Featured Stories"), React.createElement(semantic_ui_react_1.Divider, {
      section: true
    }))), this.renderSingleFeaturedStory(data_1.Stories[0]), this.renderSingleFeaturedStory(data_1.Stories[1]), React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: false
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(react_router_dom_1.Link, {
      style: {
        color: 'blue',
        float: 'right'
      },
      to: 'stories'
    }, "more stories..."))));
  };

  LandingPage.prototype.renderFeaturedVisualizations = function () {
    return React.createElement(React.Fragment, null, React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: false
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(semantic_ui_react_1.Header, {
      floated: 'left'
    }, "Featured Visualizations"), React.createElement(semantic_ui_react_1.Divider, {
      section: true
    }))), this.renderSingleVisualization(data_1.VizData.spring), this.renderSingleVisualization(data_1.VizData.tfjsTsne), React.createElement(semantic_ui_react_1.Grid.Row, {
      centered: false
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 12
    }, React.createElement(react_router_dom_1.Link, {
      style: {
        color: 'blue',
        float: 'right'
      },
      to: 'visualizations'
    }, "more visualizations..."))));
  };

  LandingPage.prototype.renderSingleFeaturedStory = function (story) {
    return React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 3
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement("img", {
      src: story.icon,
      style: {
        height: '90px',
        width: '90px'
      },
      alt: "story " + story.title + " icon"
    })), React.createElement(semantic_ui_react_1.Grid.Column, {
      textAlign: 'left',
      width: 8
    }, React.createElement(semantic_ui_react_1.Header, null, story.title), React.createElement("p", null, React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Description: "), story.description), React.createElement("p", null, React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Analysis authors: "), story.authors.length === 2 ? story.authors[0] + " and " + story.authors[1] : story.authors.join(', ')), React.createElement("br", null)), React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 2
    }, React.createElement(semantic_ui_react_1.Button, {
      basic: true
    }, React.createElement(react_router_dom_1.Link, {
      to: story.link
    }, "launch"))));
  };

  LandingPage.prototype.renderHCADatasets = function () {
    return React.createElement(semantic_ui_react_1.Grid.Column, {
      width: 3
    }, React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement("img", {
      src: 'assets/icons/hca-logo.png',
      style: {
        width: '150px',
        height: '250px'
      },
      alt: 'human cell atlas logo'
    }), React.createElement(semantic_ui_react_1.Grid.Row, null, React.createElement("a", {
      href: 'https://preview.data.humancellatlas.org/'
    }, "Search HCA datasets ..."))));
  };

  LandingPage.prototype.renderSingleUserSharedDatasets = function (dataset) {
    return React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 2
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'left'
    }, React.createElement(semantic_ui_react_1.Header, null, dataset.name), React.createElement("p", null, dataset.summary, React.createElement("br", null), React.createElement("span", {
      style: {
        fontWeight: 'bold'
      }
    }, "Authors: "), dataset.authors.join(', '))), React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'right'
    }, React.createElement(semantic_ui_react_1.Button, {
      basic: true,
      floated: 'right'
    }, React.createElement(react_router_dom_1.Link, {
      to: dataset.links.detail
    }, "details")), React.createElement(semantic_ui_react_1.Button, {
      basic: true,
      floated: 'right'
    }, React.createElement(react_router_dom_1.Link, {
      to: dataset.links.analysis
    }, "analyze"))));
  };

  LandingPage.prototype.renderUserSharedDatasets = function () {
    return React.createElement(semantic_ui_react_1.Grid.Column, {
      stretched: true,
      textAlign: 'left',
      width: 8
    }, React.createElement(semantic_ui_react_1.Grid.Row, {
      textAlign: 'center'
    }, React.createElement(semantic_ui_react_1.Header, {
      as: 'h2',
      textAlign: 'center'
    }, "User shared")), React.createElement("br", null), React.createElement(semantic_ui_react_1.Grid.Row, null, this.renderSingleUserSharedDatasets(data_1.userDatasets[0])), React.createElement(semantic_ui_react_1.Grid.Row, null, this.renderSingleUserSharedDatasets(data_1.userDatasets[1])));
  };

  return LandingPage;
}(React.Component);

exports.LandingPage = LandingPage;